import React, { Fragment } from "react";
import { createRoot } from "react-dom/client";

import { Provider } from "react-redux";
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react';

// Starting application :p
import App from "./App";

// Analytics
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
